import { MenuContainer } from './style';
import { useMsal } from '@azure/msal-react';
import Button from '../../../../Button';
import { TbSettings2 } from 'react-icons/tb';
import { TbLogout } from 'react-icons/tb';
import { TbListDetails } from 'react-icons/tb';
import { TbPlugConnected } from 'react-icons/tb';
import {
  useUpdateUserCompany,
  useUserCompanies,
  useUserCompaniesCurrentUserAdminState
} from '../../../../../services/user.service';
import { queryClient } from '../../../../../config/queryClient';
import { GET_WORKFLOW } from '../../../../../consts/queryKeys';
import { QUERY_KEYS } from '../../../../../services/constants';
import { Link, useNavigate } from 'react-router-dom';
import { USER_ROLES } from '../../../../../consts/userRoles';

export default function Menu({ closePopover }) {
  const { instance } = useMsal();
  const { data: currentUserState } = useUserCompaniesCurrentUserAdminState();

  const isApprover = currentUserState?.role === USER_ROLES.APPROVER;

  const onLogout = () => {
    instance.logoutRedirect();
  };

  return (
    <MenuContainer>
      <div className="menu-list">
        {currentUserState?.role === USER_ROLES.ADMIN && (
          <Link className="settings-button" to="/settings">
            <TbSettings2 size={16} color="#868E96" />
            Settings
          </Link>
        )}

        {!isApprover && (
          <Link className="settings-button" to="/integrations" onClick={closePopover}>
            <TbPlugConnected size={16} color="#868E96" />
            Integrations
          </Link>
        )}

        {!isApprover && (
          <Link className="settings-button" to="/activity-log" onClick={closePopover}>
            <TbListDetails size={16} color="#868E96" />
            Activity log
          </Link>
        )}

        <Button className="list-item" onClick={onLogout}>
          <TbLogout size={17} color="#868E96" />
          Logout
        </Button>
      </div>
    </MenuContainer>
  );
}
